// this file is generated by update_shopify_store_data.py at 2026-02-23 20:26:15.725528
var courses = [
    {
        "course_id": "33BA81CD-2848-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: How Respiratory Viruses Spread from Surfaces to People (Free)",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nThis module examines how respiratory viruses and other germs that may make us sick spread from surfaces in the healthcare environment to other people.\u00a0\r\nHealthcare workers of all professions may also benefit from this course.\r\nWhy is this course important to you?\r\nYou can take many actions to keep respiratory viruses from spreading from surfaces to people, including source control actions, proper hand hygiene, respiratory/cough etiquette, and good environmental cleaning and disinfection. Since respiratory droplets are the main way respiratory viruses spread, these actions are all important tools for keeping our patients, co-workers, and ourselves from breathing in each other\u2019s respiratory droplets.",
        "learning_objectives_html": "At the conclusion, participants should be able to:<br />\r\n<br />\r\nDescribe one (1) characteristic of respiratory droplets<br />\r\n<br />\r\nIdentify two (2) ways respiratory viruses can spread from surfaces to people",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01DE6ED9-D88C-EB11-80DF-005056B134EC",
                "course_category_name": "Hand Hygiene",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Infection Control",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "306B4D00-C749-E611-832F-005056B17E48",
                "course_category_name": "Environmental Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];